/**
 * @module google-recaptcha/getRecaptchaKey
 * @description
 * Получаем ключ для рендера капчи.
 * @param {DOMElement} recaptcha_block - блок для рендера рекапчи
 * @returns {string} - ключ для рендера капчи
 */
export default (recaptcha_block) => {
  let key = window.Shop.config.get('recaptcha_key').recaptcha_key;

  if (recaptcha_block.dataset.recaptchaType === 'invisible'
  || recaptcha_block.dataset.size === 'invisible') {
    key = window.Shop.config.get('recaptcha_key_v3').recaptcha_key_v3;
  }

  return key;
};
